/**
 * <offer-selector form="product-form-id">
 *
 * Wraps a radio group of .gv-offer-card__input elements (rendered by
 * snippets/gv-offer-selector.liquid). On change, syncs the selected offer's
 * variant id, quantity, and a hidden `_offer` line-item property into the
 * bound <product-form>, reusing the theme's existing hidden `id`/`quantity`
 * form inputs — no changes to ProductForm/BuyButtons/QuantityInput required.
 *
 * Dispatches a bubbling `offer:change` CustomEvent (detail: { variantId,
 * quantity, offerHandle }) so other components (sticky CTA, price summary)
 * can react without being tightly coupled to this element.
 */
if (!window.customElements.get('offer-selector')) {
	class OfferSelector extends HTMLElement {
		connectedCallback() {
			this._form = document.forms[this.getAttribute('form')]
			if (!this._form) {
				return
			}
			this._onChangeListener = this._onChange.bind(this)
			this.addEventListener('change', this._onChangeListener)

			const checkedInput = this.querySelector('.gv-offer-card__input:checked')
			if (checkedInput) {
				this._applyOffer(checkedInput)
			}
		}

		disconnectedCallback() {
			this.removeEventListener('change', this._onChangeListener)
		}

		_onChange(event) {
			if (!event.target.classList.contains('gv-offer-card__input')) {
				return
			}
			this._applyOffer(event.target)
		}

		_applyOffer(input) {
			const variantId = input.getAttribute('data-variant-id')
			const quantity = parseInt(input.getAttribute('data-quantity') || '1', 10)
			const offerHandle = input.getAttribute('data-offer-handle')

			if (variantId && this._form.elements['id']) {
				this._form.elements['id'].value = variantId
			}

			const quantityInput = this._form.querySelector('[name="quantity"]')
			if (quantityInput) {
				if ('quantity' in quantityInput) {
					quantityInput.quantity = quantity
				} else {
					quantityInput.value = quantity
				}
			}

			this._syncOfferProperty(offerHandle)

			this.dispatchEvent(
				new CustomEvent('offer:change', {
					bubbles: true,
					detail: { variantId, quantity, offerHandle },
				}),
			)
		}

		_syncOfferProperty(offerHandle) {
			let propertyInput = this._form.querySelector(
				'input[name="properties[_offer]"]',
			)
			if (!offerHandle) {
				propertyInput?.remove()
				return
			}
			if (!propertyInput) {
				propertyInput = document.createElement('input')
				propertyInput.type = 'hidden'
				propertyInput.name = 'properties[_offer]'
				this._form.appendChild(propertyInput)
			}
			propertyInput.value = offerHandle
		}
	}

	window.customElements.define('offer-selector', OfferSelector)
}
